import PropTypes from 'prop-types';
import { CloseIcon, Search } from '@/ui/icons';
import './SearchField.css';

// Search box — leading magnifier, a clear (✕) button while there's
// text, otherwise the "/" focus-shortcut hint. Controlled. Styles: .search in
// atoms.css. Mirrors the prototype's search input.
export default function SearchField({
  value = '',
  onChange,
  placeholder = 'Buscar…',
  kbd = '/',
}) {
  return (
    <label className="search">
      <Search size={15} />
      <input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
      />
      {value ? (
        <button
          type="button"
          className="search__clear"
          aria-label="Limpiar búsqueda"
          onClick={() => onChange?.('')}
        >
          <CloseIcon size={13} />
        </button>
      ) : (
        kbd && <span className="kbd">{kbd}</span>
      )}
    </label>
  );
}

SearchField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  kbd: PropTypes.string,
};
